import { useEffect } from 'react';
import { useGlobalContext } from '../components/GlobalContextProvider/GlobalContextProvider';
import {
  COVERED_TITLE_PERCENTS,
  NOT_COVERED_TITLE_PERCENTS,
} from '../consts/style-consts';

const useBreadcrumbsScrollFix = () => {
  const { setPercentOfCoveredTitle } = useGlobalContext();

  const setTitleNotCovered = () => {
    if (window.scrollY === 0) {
      setPercentOfCoveredTitle(NOT_COVERED_TITLE_PERCENTS);
    }
    if (window.scrollY > 260) {
      setPercentOfCoveredTitle(COVERED_TITLE_PERCENTS);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setTitleNotCovered);
    return () => window.removeEventListener('scroll', setTitleNotCovered);
  }, []);
};

export default useBreadcrumbsScrollFix;
